import { calculateBumpedGasPrice, calculateExtraEth } from '@exodus/ethereum-lib'

// Move to meta?
const taxes = {
  paxgold: 0.0002,
}

const getExtraFeeData = ({ asset, amount }) => {
  const tax = taxes[asset.name]
  if (!amount || !tax || amount.isZero) {
    return {}
  }

  const extraFee = amount.mul(tax)
  return {
    type: 'tax',
    tax,
    extraFee,
  }
}

export const getFeeFactory =
  ({ gasLimit: defaultGasLimit }) =>
  ({
    asset,
    feeData,
    customFee,
    gasLimit: providedGasLimit,
    isExchange,
    isSendAll,
    amount,
    isRbfAllowed = true, // Destkop, isRbfAllowed=true when advanced panel is on
    calculateEffectiveFee,
  }) => {
    const { gasPrice: feeDataGasPrice, eip1559Enabled, baseFeePerGas, tipGasPrice } = feeData

    const gasPriceMultiplier = feeData.gasPriceMultiplier || 1

    const gasPrice = customFee || feeDataGasPrice.mul(gasPriceMultiplier)

    const gasLimit = providedGasLimit || asset.gasLimit || defaultGasLimit

    const extraFeeData = getExtraFeeData({ asset, amount })
    if (calculateEffectiveFee && eip1559Enabled) {
      const maxFeePerGas = gasPrice
      // effective_gas_price = min(base_fee_per_gas + tip_gas_price, max_fee_per_gas)
      const feePerGas = baseFeePerGas.add(tipGasPrice)
      const effectiveGasPrice = feePerGas.lt(maxFeePerGas) ? feePerGas : maxFeePerGas

      return { fee: effectiveGasPrice.mul(gasLimit), gasPrice, extraFeeData }
    }

    const fee = gasPrice.mul(gasLimit)
    return { fee, gasPrice, extraFeeData }
  }

// Used in BE
export const getEffectiveGasPrice = ({ feeData }) => {
  const { baseFeePerGas, tipGasPrice, gasPrice: maxFeePerGas, eip1559Enabled } = feeData

  if (!eip1559Enabled) {
    return maxFeePerGas
  }

  const gasPrice = baseFeePerGas.add(tipGasPrice)
  return gasPrice.lt(maxFeePerGas) ? gasPrice : maxFeePerGas
}

// Used in Mobile
export const getExtraFeeForBump = ({ tx, feeData, balance, unconfirmedBalance }) => {
  if (!balance || !unconfirmedBalance) return null
  const { gasPrice: currentGasPrice, eip1559Enabled } = feeData
  const { bumpedGasPrice } = calculateBumpedGasPrice({
    baseAsset: 'ethereum',
    tx,
    currentGasPrice,
    eip1559Enabled,
  })
  return calculateExtraEth({
    fee: bumpedGasPrice.mul(tx.data.gasLimit),
    balance: balance.sub(unconfirmedBalance),
  })
}
